import React, { useState, useEffect } from 'react';
import GoogleMapReact from 'google-map-react';
import axios from 'axios';
import { apiEndpoint } from '../constants/api';

const LocationMap = ({ location }) => {
  const geoLocation = location.geo_name;
  const [coordinates, setCoordinates] = useState({ lat: 0, lng: 0 });
  const apiKey = process.env.REACT_APP_GOOGLE_MAP_KEY;

  useEffect(() => {
    const fetchCoordinates = async () => {
      try {
        const { data } = await axios.post(
          apiEndpoint(`/location/coordinates?location=${geoLocation}`)
        );
        if (data.lat && data.lng) {
          setCoordinates({ lat: data.lat, lng: data.lng });
        }
      } catch (error) {
        console.error('Error fetching coordinates:', error);
      }
    };

    if (location) {
      fetchCoordinates();
    }
  }, [location]);

  return (
    <div className="w-full h-48 bg-gray-100 rounded-lg">
      {coordinates.lat !== 0 && coordinates.lng !== 0 ? (
        <GoogleMapReact
          bootstrapURLKeys={{ key: apiKey }}
          defaultCenter={coordinates}
          defaultZoom={10}
        />
      ) : (
        <div>Loading map...</div>
      )}
    </div>
  );
};

export default LocationMap;
